import { ubicationsService } from "services";
import { listFromApiResponse } from "utils/functionsApi";

export const getAllUbications = (options) => async (dispatch) => {

	try {
		const list = await ubicationsService.getAll(options);

		if (!list.ok) {
			const msg =
				list.errors?.[0]?.description ||
				"Error al cargar las ubicaciones";
			dispatch({
				type: 'ERROR',
				payload: msg
			});
			return;
		}

		dispatch({
			type: 'GET_UBICATIONS',
			payload: listFromApiResponse(list)
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

export const getSelectableUbications = (options) => async (dispatch) => {

	try {
		const list = await ubicationsService.getSelectable(options);

		if (!list.ok) {
			console.warn("getSelectableUbications: respuesta no ok", list);
			dispatch({
				type: 'GET_SELECT_UBICATIONS',
				payload: []
			});
			return [];
		}

		const payload = listFromApiResponse(list);
		dispatch({
			type: 'GET_SELECT_UBICATIONS',
			payload
		});
		return payload;
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
		return [];
	}
}

export const getEnabledUbications = () => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await ubicationsService.getAll({ enabled: true });

		if (!list.ok) {
			const msg =
				list.errors?.[0]?.description ||
				"Error al cargar las ubicaciones";
			dispatch({
				type: 'ERROR',
				payload: msg
			});
			return;
		}

		dispatch({
			type: 'GET_UBICATIONS',
			payload: listFromApiResponse(list)
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}